import * as Yup from 'yup'
import { Dialog } from '@progress/kendo-react-dialogs'
import { useFormik } from 'formik'
import { FormControl } from '@material-ui/core'

import { Colors } from '~/styles'
import { Input, Button, InputSelect } from '~/components'

import SC from '../styled.activity'

const AddTaskActivityChecklistModal = ({
  data,
  toggleModal,
  taskLevelOptions,
  createChecklistTask,
}) => {
  const Form = useFormik({
    initialValues: {
      pic: '',
      task: '',
      level: '',
      level_value: '',
      requirement: '',
      compliance_parameter: '',
    },
    validationSchema: Yup.object({
      pic: Yup.string().required('This field is required'),
      task: Yup.string().required('This field is required'),
      level: Yup.string().required('This field is required'),
    }),
    onSubmit: async (values) => {
      const payload = {
        task: values.task,
        sr_code: data.sr_code,
        activity_code: data.code,
        sort_no : data.progress_task_header_list.length + 1,
        pic: values.pic,
        level: values.level,
        level_value: values.level_value,
        requirement: values.requirement,
        compliance_parameter: values.compliance_parameter,
        progress_task_attachment_list: []
      }

      createChecklistTask(data, payload)
    }
  })

  return (
    <Dialog onClose={toggleModal}>
      <SC.ModalTaskChecklistContainer>
        <SC.ModalTaskChecklistHeaderContainer>
          <SC.TaskChecklistHeaderTitle>
            Add New Task - {data.activity_name}
          </SC.TaskChecklistHeaderTitle>
          <div id='close-modal'>
            <SC.CloseIcon style={{ color: 'white' }} onClick={toggleModal} />
          </div>
        </SC.ModalTaskChecklistHeaderContainer>
        <SC.ModalTaskChecklistFormContainer>
          <p>Task Name*</p>
          <Input
            id='exct-mdl-act-add-task-checklist-task-input'
            form={Form}
            type='text'
            name='task'
            variant='outlined'
            placeholder='Task Name'
          />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}>
            <div>
              <p>PIC*</p>
              <Input
                id='exct-mdl-act-add-task-checklist-pic-input'
                form={Form}
                type='text'
                name='pic'
                variant='outlined'
                placeholder='Task Name'
              />
            </div>
            <div>
              <p>Level*</p>
              <FormControl variant='outlined' style={{ width: '100%' }}>
                <InputSelect
                  id='exct-mdl-act-add-task-checklist-level-input'
                  form={Form}
                  name='level'
                  value={taskLevelOptions.find((e) => e['Code'] === Form.values.level)}
                  variant='outlined'
                  options={taskLevelOptions}
                  optionText='Value'
                  optionValueKey='Value'
                  onChange={(_, val) => {
                    Form.setFieldValue('level', val ? val['Code'] : '')
                    Form.setFieldValue('level_value', val ? val['Value'] : '')
                  }}
                />
              </FormControl>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}>
            <div>
              <p>Requirement</p>
              <Input
                id='exct-mdl-act-add-task-checklist-pic-input'
                form={Form}
                type='text'
                name='requirement'
                variant='outlined'
                rowsMax={4}
                multiline
                placeholder='Requirement'
              />
            </div>
            <div>
              <p>Compliance Parameter</p>
              <Input
                id='exct-mdl-act-add-task-checklist-pic-input'
                form={Form}
                type='text'
                name='compliance_parameter'
                variant='outlined'
                rowsMax={4}
                multiline
                placeholder='Compliance Parameter'
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16, marginTop: 20 }}>
            <Button
              id='exct-mdl-act-add-task-checklist-cancel-btn'
              onClick={toggleModal}
              color='transparent'
              borderColor={Colors.wrapGray}
            >
              Cancel
            </Button>
            <Button
              id='exct-mdl-act-add-task-checklist-save-btn'
              color='blue'
              onClick={Form.handleSubmit}
            >
              Add
            </Button>
          </div>
        </SC.ModalTaskChecklistFormContainer>
      </SC.ModalTaskChecklistContainer>
    </Dialog>
  )
}

export default AddTaskActivityChecklistModal
